import { render, staticRenderFns } from "./FreeTimeMobile.vue?vue&type=template&id=f4970f08&"
import script from "./FreeTimeMobile.vue?vue&type=script&lang=js&"
export * from "./FreeTimeMobile.vue?vue&type=script&lang=js&"
import style0 from "./FreeTimeMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports